import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import util from '@utils/util';
import videoService from '@services/videoService';
import RoomList from './RoomList';
import BlankSlot from './blankSlot';
export default {
  name: 'RecommendedList',
  components: {
    RoomList: RoomList,
    BlankSlot: BlankSlot
  },
  props: {
    userInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    channel: String
  },
  data: function data() {
    return {
      VideoAPIService: null,
      pageSize: 20,
      // 1页加载个数

      pageIndex: 1,
      rdList: [],
      countryCode: 'US',
      // 记录 已经 上报的 直播列表
      lookedIds: []
    };
  },
  watch: {},
  methods: {
    onSkipLiveRoom: function onSkipLiveRoom(vid) {
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var json, local, _json;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              util.loadingFunc({
                time: 20000
              });
              util.KEWLSensorTrack({
                lmweb_clickText: '直播列表',
                lmweb_tabName: vid
              });
              // 新旧交替 直播间url 临时解决方案
              if (window.projectName == 'cheez') {
                json = {
                  pathname: "/v/".concat(vid),
                  search: {}
                };
                window.location.href = util.directToPath(json);
              } else {
                local = util.getI18nLocale();
                _json = {
                  pathname: "/".concat(local, "/v/").concat(vid, "/index.html"),
                  search: {}
                };
                window.location.href = util.directToPath(_json);
              }
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    getData: function getData() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var rdList, list, ldcList, i;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this.getFeatureList();
            case 2:
              rdList = _context2.sent;
              list = [];
              ldcList = [];
              if (_this.channel) {
                // eslint-disable-next-line no-plusplus
                for (i = 0; i <= rdList.length; i++) {
                  if (rdList[i] && _this.channel != rdList[i].vid) {
                    list.push(rdList[i]);
                  }
                }
                _this.rdList = list;
              } else {
                _this.rdList = rdList;
              }
              // 大数据曝光上报 act 1
              // this.rdList.forEach((ele) => {
              //   if (ele.c && ele.d) {
              //     ldcList.push({
              //       act: 1,
              //       c: ele.c,
              //       d: ele.d,
              //       et: '-1',
              //       v: 1
              //     })
              //   }
              // });
              // util.ldcTrack(ldcList, true);
              _this.scrollRPeport();
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    // 页面锚点到指定位置
    onScrollMore: function onScrollMore() {
      var hrefDom = document.getElementById('hrefDom');
      var sTop = 0;
      sTop = document.documentElement.scrollTop || document.body.scrollTop;
      document.documentElement.scrollTop = sTop + hrefDom.getBoundingClientRect().top - 10;
      document.body.scrollTop = sTop + hrefDom.getBoundingClientRect().top - 10;
    },
    /**
     * 获取推荐的视频
     */
    getFeatureList: function getFeatureList() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this2.VideoAPIService = videoService.createApi();
              _context3.next = 3;
              return _this2.VideoAPIService.getFeatureList(_this2.countryCode.toUpperCase(), _this2.pageIndex, _this2.pageSize, 3, 3108);
            case 3:
              return _context3.abrupt("return", _context3.sent.video_info);
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    // 滚动 上报 逻辑 
    scrollRPeport: util.debounce(function () {
      var _this3 = this;
      // 使用 vid 进行筛选
      var lookedIds = new Set();
      document.querySelectorAll('.room-list .item').forEach(function (item) {
        // 是否在可视 区域内
        if (util.isElementInViewport(item)) {
          lookedIds.add(item.getAttribute('vid') || '');
        }
      });
      var idsArr = Array.from(lookedIds);
      // 筛出 重复上报的
      if (this.lookedIds.length === 0) {
        this.lookedIds = idsArr;
      } else {
        idsArr = idsArr.filter(function (id) {
          return !_this3.lookedIds.includes(id);
        });
        this.lookedIds = [].concat(_toConsumableArray(this.lookedIds), _toConsumableArray(idsArr));
      }
      // 上报
      // 大数据曝光上报 act 1
      var ldcList = this.rdList.filter(function (item) {
        return idsArr.includes(item.vid);
      }).map(function (ele) {
        if (ele.c && ele.d) {
          return {
            act: 1,
            c: ele.c,
            d: ele.d,
            v: 1
          };
        }
      }).filter(function (it) {
        return it;
      });
      // console.log( idsArr ,'to do---scroll2bottom',ldcList);
      if (ldcList.length > 0) {
        util.ldcTrack(ldcList, true);
      }

      // 防抖 1s 上报要求停留 1s 才算看到 视为上报
    }, 1000)
  },
  mounted: function mounted() {
    var _this4 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return util.getI18nCountryCode(_this4.$route && _this4.$route.params.countryCode);
          case 2:
            _this4.countryCode = _context4.sent;
            _context4.next = 5;
            return _this4.getData();
          case 5:
            // 初始化 滚动事件
            window.addEventListener('scroll', _this4.scrollRPeport);
          case 6:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }))();
  },
  destroyed: function destroyed() {
    // 销毁 滚动事件
    window.removeEventListener('scroll', this.scrollRPeport);
  }
};